import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorDto } from '@hub/generated/models';
import { PublicController } from '@hub/generated/services';
import { AppConfigService } from '@hub/services/AppConfigService';

@Injectable()
export class GlobalErrorHandler implements  ErrorHandler {
    // Constructors
    constructor (private injector: Injector) {
  }

  handleError(error: any): void {
    if(!this.injector.get(AppConfigService).getConfig()){
      console.error(error);
      return;
    }

    if (!this.injector.get(AppConfigService).getUseMockUser()) {      
      const controller = this.injector.get(PublicController);
      const e: ErrorDto = new ErrorDto();
      e.Subject = "Client - " + error.message;
      e.Message = error.message;
      if (error.stack)
        e.Stack = error.stack;
      else {
        // if there is no stack we will get atleast where it happened
        if (error.error && error.error.target && error.error.target.__zone_symbol__xhrURL)
          e.Stack = error.error.target.__zone_symbol__xhrURL;
      }
      controller.LogError(e).subscribe(result => { });
    }

    // IMPORTANT: Rethrow the error otherwise it gets swallowed
     throw error;
  }
}
